import { DateTime } from 'luxon'

export class ContentCategory {
	public id: number
	public name: string
	public key: string
	public parentId: number | null
	public tags: string[]
	public showInSchedules: boolean
	public showInPlaylists: boolean
	public autoHideAtSchedules: DateTime | null
	public autoHideAtPlaylists: DateTime | null
	public positionSchedules: number | null
	public positionPlaylists: number | null
	public createdAt: DateTime
	public updatedAt: DateTime
	public parent?: ContentCategory
	public subcategories?: ContentCategory[]

	constructor(data: {
		id: number
		name: string
		key: string
		parentId: number | null
		tags: string[]
		showInSchedules: boolean
		showInPlaylists: boolean
		autoHideAtSchedules: DateTime | null
		autoHideAtPlaylists: DateTime | null
		positionSchedules: number | null
		positionPlaylists: number | null
		createdAt: DateTime
		updatedAt: DateTime
		parent?: ContentCategory
		subcategories?: ContentCategory[]
	}) {
		this.id = data.id
		this.name = data.name
		this.key = data.key
		this.parentId = data.parentId
		this.tags = data.tags
		this.showInSchedules = data.showInSchedules
		this.showInPlaylists = data.showInPlaylists
		this.autoHideAtSchedules = data.autoHideAtSchedules
		this.autoHideAtPlaylists = data.autoHideAtPlaylists
		this.positionSchedules = data.positionSchedules
		this.positionPlaylists = data.positionPlaylists
		this.createdAt = data.createdAt
		this.updatedAt = data.updatedAt
		this.parent = data.parent
		this.subcategories = data.subcategories
	}

	getLocalizedName(_locale?: string): string {
		return this.name
	}

	static create(partial: Partial<ContentCategory>): ContentCategory {
		const defaults = {
			id: 0,
			name: '',
			key: '',
			parentId: null,
			tags: [],
			showInSchedules: false,
			showInPlaylists: false,
			autoHideAtSchedules: null,
			autoHideAtPlaylists: null,
			positionSchedules: null,
			positionPlaylists: null,
			createdAt: DateTime.now(),
			updatedAt: DateTime.now(),
			parent: undefined,
			subcategories: undefined,
		}

		return new ContentCategory({ ...defaults, ...partial })
	}
}
